export default __webpack_public_path__ + "static/media/gallery_02.22329227.jpg";